export interface IUpdateEmailTemplate<T> {
    data: T;
}
